import AWS from 'aws-sdk/global';

import {
  AUTH_USER_POOL_ID,
  AUTH_REGION,
  AUTH_COGNITO_IDENTITY_POOL_ID,
} from './constants';

export function configureAWSCredentialsWithToken(token: string): Promise<void> {
  const awsCredentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AUTH_COGNITO_IDENTITY_POOL_ID,
    Logins: {
      // Change the key below according to the specific region your user pool is in.
      [`cognito-idp.${AUTH_REGION}.amazonaws.com/${AUTH_USER_POOL_ID}`]: token,
    },
  });

  // extract the region from the Identity Pool ID
  AWS.config.region = AUTH_COGNITO_IDENTITY_POOL_ID.split(':')[0];
  // configure the SDK to make use of the Cognito-provided credentials
  AWS.config.credentials = awsCredentials;
  // load credentials and set them up to refresh
  return awsCredentials.getPromise();
}
